import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, tap, withLatestFrom } from 'rxjs/operators';
import { Observable, EMPTY } from 'rxjs';

import * as HomeStoreActions from './home-store.actions';
import { ContentService } from 'src/app/shared/services/content.service';
import { HomeActions, HomeSelectors } from '..';
import { Store } from '@ngrx/store';

@Injectable()
export class HomeStoreEffects {
    loadHomeStores$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(HomeStoreActions.loadHomeStores),
            /** An EMPTY observable only emits completion. Replace with your own observable API request */
            concatMap(() => EMPTY as Observable<{ type: string }>)
        );
    });

    // load news from api with count param and dispatch loadNewsSuccess action
    loadNews$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(HomeStoreActions.loadNews),
                tap((action) => {
                    this.contentService
                        .getNews(action.count)
                        .subscribe((news) => {
                            this.store.dispatch(
                                HomeActions.loadNewsSuccess({ news })
                            );
                        });
                })
            );
        },
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private contentService: ContentService,
        private store: Store
    ) {}
}
